import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import $ from "jquery";
import React, { useEffect, useState } from "react";
import S3 from "react-aws-s3";
import * as XLSX from "xlsx";

import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import "../NewBasic/NewBasic.css";
import "../NewBasicProject/NewBasicProject.css";

import TextField from "@material-ui/core/TextField";

import AssessmentIcon from "@material-ui/icons/Assessment";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Auth } from "aws-amplify";
import { useParams } from "react-router-dom";

import { Divider, Fade } from "@material-ui/core";
import { API } from "aws-amplify";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import {
  createEduvanceAITool,
  updateEduvanceAITool,
} from "../../graphql/mutations";
import { testfetchFunction } from "../fetchData";
import TestingForm from "../TesttingForm/TestingForm";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    // width: '60vw',
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  root: {
    width: "100%",
    minWidth: "100%",
    marginBottom: "2vh",
    color: "$060606",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "45%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "30%",
    color: "#eee",
  },
  terinoaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    textAlign: "right",
  },
}));

export default function NewBasic(params) {
  const classes = useStyles();
  let traintimer;
  let { uname, pname } = useParams();
  const [expanded, setExpanded] = React.useState(false);
  const [uploadMode, setUploadMode] = useState("");
  const [value, setValue] = useState(80);
  const [epochs, setEpochs] = useState(5);
  const [filename, setFileName] = useState("No file uploaded");
  const [open, setOpen] = React.useState(false);
  const [columns, setColumns] = useState([]);
  const [ipColumns, setIpColumns] = useState([]);
  const [opColumns, setOpColumns] = useState([]);
  const [zipfile, setZipFile] = useState("");
  const [data, setData] = useState([]);
  const [fileData, setFileData] = useState("");
  const [modelSaved, setModelSaved] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [progressBar, setProgressBar] = useState(false);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(true);
  const [responseJson, setResponseJson] = useState("");
  const [couponcheck, setCouponCheck] = useState("");
  const [responseOutput, setResponseOutput] = useState("");
  const [oldPName, setOldPName] = useState("untitled");
  const [showScores, setShowScore] = useState(false);
  const [algoType, setAlgoType] = useState("");
  const [profileCreated, setProfileCreated] = useState("no");

  const [inputselected, setInputSelected] = useState(false);
  const [splitselected, setSplitSelected] = useState(false);
  const [algoselected, setAlgoSelected] = useState(false);
  const [builded, setBuilded] = useState(false);
  const [trained, setTrained] = useState(false);
  const [skipreport, setskipreport] = useState(false);
  const [animationran, setAnimationran] = useState(false);
  const [animationdone, setAnimationdone] = useState(false);
  const [linkupload, setLinkupload] = useState("");
  const [mappingjson, setMappingJson] = useState({
    inputs: "",
    outputs: "",
    algorithm: "",
    testsize: "",
    epochs: "",
  });

  const [progressLines, setProgressLines] = useState({
    one: "nostarted",
    two: "nostarted",
    three: "nostarted",
    four: "nostarted",
    five: "nostarted",
  });

  const [progessJson, setProgressJson] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
  });

  const [AlgoData, setAlgoData] = useState(null);
  var oldDate, newDate;
  var oldEDA, newEDA;
  useEffect(() => {
    if (progressLines["three"] === "completed" && animationran) {
      setAnimationran(false);
      setTimeout(() => {
        setProgressLines((e) => {
          return { ...e, four: "started" };
        });
      }, 100);
      setTimeout(() => {
        setProgressLines((e) => {
          return { ...e, four: "completed" };
        });
        setProgressLines((e) => {
          return { ...e, five: "started" };
        });
      }, 5000);
      setTimeout(() => {
        setProgressLines((e) => {
          return { ...e, five: "completed" };
        });
        setTrained(true);
        setShowScore(true);
        setAnimationdone(false);
      }, 10000);
    }
    document.getElementById("pname").value = pname;
  }, [progressLines.three]);

  const resetInputs = () => {
    setIpColumns([]);
    setOpColumns([]);

    console.log(progessJson);
    if (uploadMode === "upload") {
      handleFileUpload();
    } else {
      handleLinkUpload();
    }
  };
  useEffect(() => {
    //localStorage.getItem("CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser")
    fetch(
      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${uname}/${pname}_config.json`,
    )
      .then((res) => res.json())
      .then((data) => {
        setLinkupload(data["datafile"]);
        setAlgoData(data);
        // console.log(data)
        setValue(100 - data["testsize"] * 100);
        if (data["algorithm"] === "IC") {
          setAlgoType("IC");
        } else if (data["algorithm"] === "Perceptron") {
          setAlgoType("classification");
        } else if (data["algorithm"] === "RFC") {
          document.querySelector("#RFC").checked = true;
          setAlgoType("classification");
        } else if (data["algorithm"] === "SVC") {
          document.querySelector("#SVC").checked = true;
          setAlgoType("classification");
        } else if (data["algorithm"] === "DTC") {
          document.querySelector("#DTC").checked = true;
          setAlgoType("classification");
        } else if (data["algorithm"] === "OLS") {
          document.querySelector("#OLS").checked = true;
          setAlgoType("regression");
        } else if (data["algorithm"] === "SGD") {
          document.querySelector("#SGD").checked = true;
          setAlgoType("regression");
        } else if (data["algorithm"] === "DTR") {
          document.querySelector("#DTR").checked = true;
          setAlgoType("regression");
        } else if (data["algorithm"] === "RFR") {
          document.querySelector("#RFR").checked = true;
          setAlgoType("regression");
        }
        initData();
        setIpColumns([]);
        setOpColumns([]);
        data["inputs"].map((e) => {
          setIpColumns((prevarray) => {
            return [...prevarray, { name: e, selector: e }];
          });
        });
        data["outputs"].map((e) => {
          setOpColumns((prevarray) => {
            return [...prevarray, { name: e, selector: e }];
          });
        });
        handleLinkUploadinit();
      });
  }, []);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const initData = () => {
    setProfileCreated("true");
    setskipreport(true);
    setProgressJson((e) => {
      return { ...e, 1: true };
    });
    setInputSelected(true);
    setSplitSelected(true);
    setAlgoSelected(true);
    setUploadMode("link");
  };

  const handleProgressJsonChange = (panel, value) => {
    let tempp = progessJson;
    tempp[panel] = value;
    console.log(JSON.stringify(tempp));
    setProgressJson((e) => {
      return { ...e, panel: value };
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleepochchange = (event, newValue) => {
    setEpochs(newValue);
  };
  const handleUploadModeChange = (event) => {
    setUploadMode(event);
  };
  const handleProfileChange = (event) => {
    setProfileCreated(event);
  };
  const processData = (dataString) => {
    const dataStringLines = dataString.split(/\r\n|\n/);
    const headers = dataStringLines[0].split(
      /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/,
    );

    const list = [];
    for (let i = 1; i < dataStringLines.length; i++) {
      const row = dataStringLines[i].split(
        /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/,
      );
      if (headers && row.length == headers.length) {
        const obj = {};
        for (let j = 0; j < headers.length; j++) {
          let d = row[j];
          if (d.length > 0) {
            if (d[0] == '"') d = d.substring(1, d.length - 1);
            if (d[d.length - 1] == '"') d = d.substring(d.length - 2, 1);
          }
          if (headers[j]) {
            obj[headers[j]] = d;
          }
        }

        // remove the blank rows
        if (Object.values(obj).filter((x) => x).length > 0) {
          list.push(obj);
        }
      }
    }

    // prepare columns list from headers
    const columns = headers.map((c) => ({
      name: c,
      selector: c,
    }));

    setData(list);
    setColumns(columns);

    handleAccordionChange("panel2");
  };
  const handleFileUpload = (element) => {
    progessJson["1"] = false;
    //reset everything here
    setProgressJson((e) => {
      return { ...e, 1: false };
    });
    setProgressLines({
      one: "nostarted",
      two: "nostarted",
      three: "nostarted",
      four: "nostarted",
      five: "nostarted",
    });
    setProfileCreated("no");
    setAnimationran(false);
    setInputSelected(false);
    setSplitSelected(false);
    setAlgoSelected(false);
    setBuilded(false);
    setShowScore(false);
    setAnimationdone(false);
    setTrained(false);
    setColumns([]);
    setZipFile("");
    handleUploadModeChange("upload");
    //document.getElementById("outlined-basic").value = "";
    let e = element;
    const fileName = e.target.value.split("\\");
    setFileName(fileName[fileName.length - 1]);
    let tempfile = fileName[fileName.length - 1];

    if (tempfile.includes(".csv")) {
      const file = e.target.files[0];
      const reader = new FileReader();
      let fileData = new FileReader();

      fileData.onloadend = (event) => {
        const content = event.target.result;
        setFileData(content);
      };
      fileData.readAsText(file);

      reader.onload = (evt) => {
        /* Parse data */
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
        processData(data);
      };
      reader.readAsBinaryString(file);
    } else if (tempfile.includes(".zip")) {
      const file = e.target.files[0];
      let fileData = new FileReader();
      setZipFile(file);
      fileData.onloadend = (event) => {
        const content = event.target.result;
        setFileData(content);
      };
      fileData.readAsArrayBuffer(file);
    }
  };

  const handleLinkUploadinit = (element) => {
    document.getElementById("contained-button-file").value = "";

    // let e = element;
    // const fileName = e.target.value.split('\\');

    // setFileName(fileName[fileName.length-1]);
    let tempfile = document.getElementById("outlined-basic").value;
    // console.log("here is link " + tempfile);

    if (tempfile.includes(".csv")) {
      fetch(tempfile)
        .then((response) => response.text())
        .then((response) => {
          let textdata = response;
          setFileData(textdata);

          // console.log("here id bstr " + textdata);
          const wb = XLSX.read(textdata, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
          processData(data);
        });
    } else if (tempfile.includes(".zip")) {
      setZipFile(tempfile);
    }
  };
  const handleLinkUpload = (element) => {
    //progessJson["1"] = false;
    //setProgressJson(e => { return { ...e, "1": false } })
    setProfileCreated("no");
    setProgressLines({
      one: "nostarted",
      two: "nostarted",
      three: "nostarted",
      four: "nostarted",
      five: "nostarted",
    });
    setInputSelected(false);
    setAnimationran(false);
    setSplitSelected(false);
    setAlgoSelected(false);
    setAnimationdone(false);
    setBuilded(false);
    setShowScore(false);
    setTrained(false);
    setColumns([]);
    setZipFile("");
    setFileName("No file uploaded");
    setUploadMode("link");
    document.getElementById("contained-button-file").value = "";

    // let e = element;
    // const fileName = e.target.value.split('\\');

    // setFileName(fileName[fileName.length-1]);
    let tempfile = document.getElementById("outlined-basic").value;
    // console.log("here is link " + tempfile);

    if (tempfile.includes(".csv")) {
      fetch(tempfile)
        .then((response) => response.text())
        .then((response) => {
          let textdata = response;
          setFileData(textdata);

          // console.log("here id bstr " + textdata);
          const wb = XLSX.read(textdata, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
          processData(data);
        });
    } else if (tempfile.includes(".zip")) {
      setZipFile(tempfile);
    }
  };
  async function saveModelSilently(mapping) {
    try {
      let tempd = await API.graphql({
        query: createEduvanceAITool,
        variables: {
          input: {
            projectname: mapping["username"] + "//Basic//" + mapping["project"],
            user: mapping["username"],
            projectType: "Basic",
            projectData: JSON.stringify(mapping),
          },
        },
      });
    } catch {
      let tempd = await API.graphql({
        query: updateEduvanceAITool,
        variables: {
          input: {
            projectname: mapping["username"] + "//Basic//" + mapping["project"],
            user: mapping["username"],
            projectType: "Basic",
            projectData: JSON.stringify(mapping),
          },
        },
      });
    }
  }

  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return "Please wait uploading dataset";
      case 1:
        return uploadMode === "link"
          ? "Reading " + document.getElementById("outlined-basic").value
          : "Reading " + filename + "file";
      case 2:
        if (mappingjson["algorithm"] !== "IC")
          return `train-test split: ${(1 - mappingjson["testsize"]) * 100}-${mappingjson["testsize"] * 100}`;
        else
          return `train-test split: ${(1 - mappingjson["testsize"]) * 100}-${mappingjson["testsize"] * 100}
                cycles: ${mappingjson["epochs"]}`;
      case 3:
        if (mappingjson["algorithm"] !== "IC")
          return `Training the model with ${mappingjson["algorithm"]} algorithm on ${(1 - mappingjson["testsize"]) * 100}% of the dataset`;
        else return "Training the model with Image Classifier algorithm";
      case 4:
        return `Testing the model on ${mappingjson["testsize"] * 100}% of the dataset`;
      case 5:
        return "Model trained";
      default:
        return "Unknown step";
    }
  };
  const trainModel = () => {
    var mapping = {};

    oldDate = getConfigDate(
      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      )}/${document.getElementById("pname").value.trim()}_config.json`,
      "Last-Modified",
    );
    mapping["username"] = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    mapping["project"] = document.getElementById("pname").value;
    if (uploadMode === "link") {
      mapping["datafile"] = document.getElementById("outlined-basic").value;
    } else {
      mapping["datafile"] =
        `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${mapping["username"]}/${document.getElementById("pname").value}.csv`;
    }
    mapping["algorithm"] = $("input[name='mlmodel']:checked").val();
    mapping["testsize"] = (100 - value) * 0.01;
    mapping["epochs"] = epochs;
    mapping["inputs"] = [];
    mapping["outputs"] = [];
    if (localStorage.getItem("validity") === "free") {
      mapping["validity"] = "free";
    } else {
      mapping["validity"] = "premium";
    }
    setMappingJson(mapping);
    let temp = document.querySelectorAll('[id^="ip"]');
    temp.forEach((e) => {
      // console.log(e.value);
      if (document.getElementById(`ip${e.value}`).checked) {
        mapping["inputs"].push(e.value);
      }
    });
    temp = document.querySelectorAll('[id^="op"]');
    temp.forEach((e) => {
      // console.log(e.value);
      if (document.getElementById(`op${e.value}`).checked) {
        mapping["outputs"].push(e.value);
      }
    });
    var data = JSON.stringify(mapping);
    var xhr = new XMLHttpRequest();
    saveModelSilently(mapping);
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        // console.log(this.responseText);
        var valjson = {};
        try {
          valjson = JSON.parse(this.response);
          if (valjson["body"] === '"Daily limit reached!"') {
            alert("Daily limit reached!");
            // setModalOpen(false);
            setActiveStep(0);
          } else {
            try {
              traintimer = setInterval((timerfun) => {
                newDate = getConfigDate(
                  `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem(
                    "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
                  )}/${document
                    .getElementById("pname")
                    .value.trim()}_config.json`,
                  "Last-Modified",
                );
                console.log(oldDate, newDate);
                if (newDate > oldDate) {
                  getConfigJson();
                  setProgressBar(false);
                  clearInterval(traintimer);
                }
              }, 8000);
            } catch (e) {
              console.log(e);
            }
          }
        } catch {
          console.log("Error");
        }
      }
    });

    xhr.open(
      "POST",
      "https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/train",
    );
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send(data);
    setTimeout(() => {
      setProgressLines((e) => {
        return { ...e, three: "completed" };
      });
    }, 30000);
  };

  const handleModelOpen = () => {
    getStepContent();
    if (document.getElementById("pname").value === "") {
      alert("Please enter project name");
    } else {
      if ($("input[name='mlmodel']:checked").val()) {
        if (uploadMode === "link") {
          setActiveStep((prevActiveStep) => 0);
          setProgressBar(true);
          // setModalOpen(true);
          setResponseJson("");
          setModelSaved(false);
          trainModel();
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setNextButtonDisabled(false);
          setBuilded(true);
          //   setProgressBar(false);
          oldDate = getConfigDate(
            `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem(
              "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
            )}/${document.getElementById("pname").value.trim()}_config.json`,
            "Last-Modified",
          );
        } else if (uploadMode === "upload") {
          setActiveStep((prevActiveStep) => 0);
          // setModalOpen(true);
          setResponseJson("");
          setModelSaved(false);

          testfetchFunction(
            Auth.user.username,
            fileData,
            document.getElementById("pname").value,
            () => {
              trainModel();
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              setNextButtonDisabled(false);
              setBuilded(true);
            },
          );
        } else {
          alert("Please Upload Datafile!");
        }
      } else {
        alert("Please select algorithm");
      }
    }
  };
  function getConfigDate(url, wch) {
    try {
      var req = new XMLHttpRequest();
      req.open("GET", url, false);
      req.setRequestHeader("Cache-Control", "no-cache");
      req.send(null);
      if (req.status === 200) {
        return new Date(req.getResponseHeader(wch));
      } else return false;
    } catch (er) {
      return er.message;
    }
  }

  const getConfigJson = () => {
    fetch(
      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      )}/${document.getElementById("pname").value.trim()}_config.json`,
    )
      .then((response) => response.json())
      .then((json) => {
        setResponseJson(json);
        setNextButtonDisabled(false);
        setProgressBar(false);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        if (json["algorithm"] === "IC") {
          setAlgoType("IC");
        } else if (json["algorithm"] === "Perceptron") {
          setAlgoType("classification");
        } else if (json["algorithm"] === "RFC") {
          setAlgoType("classification");
        } else if (json["algorithm"] === "SVC") {
          setAlgoType("classification");
        } else if (json["algorithm"] === "DTC") {
          setAlgoType("classification");
        } else if (json["algorithm"] === "OLS") {
          setAlgoType("regression");
        } else if (json["algorithm"] === "SGD") {
          setAlgoType("regression");
        } else if (json["algorithm"] === "DTR") {
          setAlgoType("regression");
        } else if (json["algorithm"] === "RFR") {
          setAlgoType("regression");
        }
      });
  };

  async function generateEDAAnalysis() {
    if (uploadMode !== "link" && uploadMode !== "upload") {
      alert("Please upload Dataset ");
    } else {
      let mapping = {};
      mapping["username"] = Auth.user.username;
      mapping["project"] = document.getElementById("pname").value.trim();

      if (uploadMode === "upload") {
        handleProfileChange("creating");
        setskipreport(false);

        oldEDA = getConfigDate(
          `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${
            Auth.user.username
          }/${document.getElementById("pname").value.trim()}.html`,
          "Last-Modified",
        );

        testfetchFunction(Auth.user.username, fileData, pname, () => {
          var data = JSON.stringify(mapping);
          var xhr = new XMLHttpRequest();

          xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
              var valjson = {};
              try {
                valjson = JSON.parse(this.response);
                if (valjson["body"] === '{"message": "Profiling Created"}') {
                  console.log("created");
                  handleProfileChange("true");
                } else {
                  try {
                    var timerfuneda = setInterval((timerfuneda) => {
                      newEDA = getConfigDate(
                        `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${
                          Auth.user.username
                        }/${document.getElementById("pname").value.trim()}.html`,
                        "Last-Modified",
                      );
                      if (newEDA > oldEDA) {
                        handleProgressJsonChange("2", true);
                        handleProfileChange("true");
                        handleProgressJsonChange("2", true);
                        clearInterval(timerfuneda);
                      }
                    }, 8000);
                  } catch (e) {
                    console.log(e);
                  }
                }
              } catch {
                console.log("Error");
                try {
                  var timerfunedaerr = setInterval((e) => {
                    newEDA = getConfigDate(
                      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${
                        Auth.user.username
                      }/${document.getElementById("pname").value.trim()}.html`,
                      "Last-Modified",
                    );
                    console.log("new date : " + newEDA + " old date " + oldEDA);
                    if (newEDA > oldEDA) {
                      handleProfileChange("true");
                      clearInterval(timerfunedaerr);
                    }
                  }, 8000);
                } catch (e) {
                  console.log(e);
                }
              }
            }
          });
          xhr.open(
            "POST",
            "https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/eda",
          );
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.send(data);
        });
        mapping["datafile"] =
          `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${Auth.user.username}/untitled.csv`;
      } else {
        handleProfileChange("creating");
        setskipreport(false);

        mapping["datafile"] = document.getElementById("outlined-basic").value;
        var data = JSON.stringify(mapping);
        var xhr = new XMLHttpRequest();

        oldEDA = getConfigDate(
          `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${
            Auth.user.username
          }/${document.getElementById("pname").value.trim()}.html`,
          "Last-Modified",
        );
        xhr.addEventListener("readystatechange", function () {
          if (this.readyState === 4) {
            var valjson = {};
            try {
              valjson = JSON.parse(this.response);
              if (valjson["body"] === '{"message": "Profiling Created"}') {
                console.log("created");
                handleProfileChange("true");
              } else {
                try {
                  var timerfuneda = setInterval((timerfuneda) => {
                    newEDA = getConfigDate(
                      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${
                        Auth.user.username
                      }/${document.getElementById("pname").value.trim()}.html`,
                      "Last-Modified",
                    );
                    if (newEDA > oldEDA) {
                      handleProgressJsonChange("2", true);
                      handleProfileChange("true");
                      handleProgressJsonChange("2", true);
                      clearInterval(timerfuneda);
                    }
                  }, 8000);
                } catch (e) {
                  console.log(e);
                }
              }
            } catch {
              console.log("Error");
              try {
                var timerfunedaerr = setInterval((e) => {
                  newEDA = getConfigDate(
                    `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${
                      Auth.user.username
                    }/${document.getElementById("pname").value.trim()}.html`,
                    "Last-Modified",
                  );
                  //console.log("new date : " + newEDA + " old date " + oldEDA);
                  if (newEDA > oldEDA) {
                    handleProfileChange("true");
                    clearInterval(timerfunedaerr);
                  }
                }, 8000);
              } catch (e) {
                console.log(e);
              }
            }
          }
        });
        xhr.open(
          "POST",
          "https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/eda",
        );
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(data);
      }
    }
  }

  const handleTextAnimations = () => {
    setAnimationdone(true);
    setAnimationran(true);
    setProgressLines((e) => {
      return { ...e, one: "" };
    });
    setTimeout(() => {
      setProgressLines((e) => {
        return { ...e, one: "started" };
      });
    }, 5000);
    setTimeout(() => {
      setProgressLines((e) => {
        return { ...e, one: "completed" };
      });
      setProgressLines((e) => {
        return { ...e, two: "started" };
      });
    }, 13000);
    setTimeout(() => {
      setProgressLines((e) => {
        return { ...e, two: "completed" };
      });
      setProgressLines((e) => {
        return { ...e, three: "started" };
      });
    }, 21000);
  };
  return (
    <>
      <div>
        <div>
          <img
            id="backgroundmainimage"
            alt="BG"
            src="/assets/images/background/MainBackground.png"
          />
        </div>

        <div
          id="corremat"
          style={{
            display: "none",
            position: "absolute",
            zIndex: "12",
            backgroundColor: "rgba(0,0,0,0.3)",
            width: "100vw",
            height: "100vh",
          }}
        >
          <div
            style={{
              position: "relative",
              left: "18vw",
              top: "20vh",
              display: "flex",
              justifyContent: "flex-start",
              width: "60vw",
              height: "60vh",
              borderRadius: "6px",
            }}
          >
            <Button
              style={{ position: "relative", right: "-56vw", top: "1vh" }}
              onClick={() => {
                document.getElementById("corremat").style.display = "none";
              }}
              variant="contained"
              color="secondary"
            >
              X
            </Button>
            <img
              id="heatmap"
              alt="heatmap_img"
              style={{
                width: "72vw",
                height: "66vh",
                border: "6px solid grey",
                borderRadius: "12px",
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
              src={``}
            />
          </div>
        </div>

        <div
          className="container-fluid navcontent"
          style={{ position: "fixed" }}
        >
          <div className="row justify-content-between">
            <div className="col-auto align-self-end">
              <div>
                <Grid
                  style={{ display: "flex", position: "relative", zIndex: "4" }}
                >
                  <Grid item>
                    <Link to="/basic">
                      <Button
                        variant="contained"
                        color="primary"
                        component="span"
                      >
                        Back
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              </div>
            </div>
            <div className="col-auto align-self-end">
              <Grid container spacing={1}>
                <Grid
                  item
                  style={{ display: "", position: "relative", zIndex: "4" }}
                >
                  <input
                    id="pname"
                    className="myinput"
                    type="text"
                    placeholder="Enter project name"
                  />
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    onClick={() => {}}
                  >
                    {" "}
                    Save project
                  </Button>
                  &nbsp;
                </Grid>
              </Grid>
            </div>
            <div className="col-auto align-self-end">
              <Grid
                container
                spacing={1}
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Grid item>
                  <Link to="/">
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                    >
                      Home
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>

        {/*########################### asli maja idhar se start hota hai ############################ */}
        <div
          className={classes.root}
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "start",
            width: "220%",
            paddingTop: "10%",
          }}
        >
          {/* upload file */}
          <div className="upload-dataset dataset-card">
            <div className="sub-header">
              <p>Step 1</p>
              {progessJson["1"] && (
                <img src="/assets/images/icons/completed.png" alt="icon" />
              )}

              {animationdone && <div className="blocker"></div>}
            </div>
            <h4 className="sub-title">Upload Dataset</h4>
            <Divider style={{ background: "#888", marginTop: "1rem" }} />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "1rem 0",
                alignItems: "end",
              }}
            >
              <p style={{ width: "55%", wordWrap: "break-word" }}>{filename}</p>
              <label htmlFor="contained-button-file">
                <p className="btn"> Choose file</p>
              </label>
            </div>
            <h4 style={{ textAlign: "center" }}>OR</h4>
            <input
              hidden={true}
              accept=".csv"
              id="contained-button-file"
              type="file"
              onChange={handleFileUpload}
            />
            <TextField
              id="outlined-basic"
              style={{ width: "11rem", color: "black" }}
              placeholder="Enter Link"
              value={linkupload}
              onChange={(e) => {
                setLinkupload(e.target.value);
              }}
            />
            <p onClick={handleLinkUpload} className="btn">
              Upload
            </p>
          </div>

          {progessJson["1"] ? (
            <img
              className="arrow"
              src="/assets/images/icons/green-arrow.png"
              alt="icon"
            />
          ) : (
            <img
              className="arrow"
              src="/assets/images/icons/arrow.png"
              alt="icon"
            />
          )}

          {/* EDA */}
          <div className="EDA dataset-card">
            {!progessJson["1"] && <div className="blocker"></div>}
            {animationdone && <div className="blocker"></div>}
            <div className="sub-header">
              <p>Step 2</p>

              {profileCreated === "true" && (
                <img src="/assets/images/icons/completed.png" alt="icon" />
              )}
            </div>
            <h4 className="sub-title">EDA</h4>
            {profileCreated === "creating" ? (
              <Button
                variant="contained"
                color="primary"
                component="span"
                startIcon={<CircularProgress />}
                onClick={() => {
                  generateEDAAnalysis();
                  console.log("generating");
                }}
                disabled={true}
                size="small"
                style={{ color: "white" }}
              >
                Generate EDA Report
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                component="span"
                startIcon={<AssessmentIcon />}
                onClick={() => {
                  generateEDAAnalysis();
                  console.log("generating");
                }}
                disabled={false}
                size="small"
              >
                Generate EDA Report
              </Button>
            )}
            {!skipreport ? (
              profileCreated === "true" ? (
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  startIcon={<OpenInNewIcon />}
                  disabled={false}
                  size="small"
                  style={{ marginTop: "0.5rem" }}
                  onClick={() => {
                    window.open(
                      `/eda/${Auth.user.username}/${
                        document.getElementById("pname").value
                      }`,
                      "_blank",
                      "noopener,noreferrer",
                    );
                  }}
                >
                  Open EDA Report
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  startIcon={<OpenInNewIcon />}
                  disabled={true}
                  size="small"
                  style={{ background: "#888", marginTop: "0.5rem" }}
                >
                  Open EDA Report
                </Button>
              )
            ) : (
              ""
            )}
            {profileCreated !== "true" && (
              <Button
                variant="contained"
                color="primary"
                component="span"
                onClick={() => {
                  setProfileCreated("true");
                  setskipreport(true);
                }}
                disabled={false}
                size="small"
                style={{ marginTop: "0.5rem" }}
              >
                Skip EDA Report
              </Button>
            )}
          </div>

          {profileCreated === "true" ? (
            <img
              className="arrow"
              src="/assets/images/icons/green-arrow.png"
              alt="icon"
            />
          ) : (
            <img
              className="arrow"
              src="/assets/images/icons/arrow.png"
              alt="icon"
            />
          )}
          {/* parameter selection */}
          <div className="parameter-selection dataset-card">
            {profileCreated !== "true" && <div className="blocker"></div>}
            {animationdone && <div className="blocker"></div>}
            <div className="sub-header">
              <p>Step 3</p>

              {inputselected && (
                <img src="/assets/images/icons/completed.png" alt="icon" />
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                padding: "0.5rem 0",
                alignItems: "end",
              }}
            >
              <h4 className="sub-title">Parameter Selection</h4>
              <p onClick={resetInputs} className="btn">
                Reset
              </p>
            </div>
            <div className="card-body text-left input-card mt-0 ml-2 mr-2">
              <Grid container spacing={2}>
                <Grid item>Select Inputs:&nbsp;&nbsp;&nbsp;</Grid>
                <Grid item xs>
                  {ipColumns.length >= 1 ? (
                    <>
                      {ipColumns.map((element) => (
                        <div key={element.name}>
                          <input
                            id={`ip${element.name}`}
                            checked
                            style={{ transform: "scale(1.5)" }}
                            type="checkbox"
                            name={element.name}
                            value={element.name}
                          />
                          <label htmlFor="inputs1">
                            &nbsp; {element.name}{" "}
                          </label>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {columns.map((element) => (
                        <div key={element.name}>
                          <input
                            id={`ip${element.name}`}
                            style={{ transform: "scale(1.5)" }}
                            type="checkbox"
                            name={element.name}
                            value={element.name}
                          />

                          <label htmlFor="inputs1">
                            &nbsp; {element.name}{" "}
                          </label>
                        </div>
                      ))}
                    </>
                  )}
                </Grid>
              </Grid>
            </div>
            <div className="card-body text-left input-card m-2">
              <Grid container spacing={2}>
                <Grid item>Select Outputs:</Grid>
                <Grid item xs>
                  {opColumns.length >= 1 ? (
                    <>
                      {opColumns.map((element) => (
                        <div>
                          <input
                            id={`op${element.name}`}
                            checked
                            style={{ transform: "scale(1.5)" }}
                            type="checkbox"
                            name={element.name}
                            value={element.name}
                          />
                          <label htmlFor="outputs1">
                            &nbsp; {element.name}{" "}
                          </label>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {columns.map((element) => (
                        <div>
                          <input
                            id={`op${element.name}`}
                            style={{ transform: "scale(1.5)" }}
                            type="checkbox"
                            name={element.name}
                            value={element.name}
                          />
                          <label htmlFor="outputs1">
                            &nbsp; {element.name}{" "}
                          </label>
                        </div>
                      ))}
                    </>
                  )}
                </Grid>
              </Grid>
            </div>
            <p
              onClick={() => {
                let input = 0,
                  output = 0;
                let temp = document.querySelectorAll('[id^="ip"]');
                temp.forEach((e) => {
                  // console.log(e.value);
                  if (document.getElementById(`ip${e.value}`).checked) {
                    input++;
                  }
                });
                temp = document.querySelectorAll('[id^="op"]');
                temp.forEach((e) => {
                  // console.log(e.value);
                  if (document.getElementById(`op${e.value}`).checked) {
                    output++;
                  }
                });
                if (input > 0 && output > 0) {
                  setInputSelected(true);
                } else {
                  Swal.fire("Please select inputs and outputs.");
                }
              }}
              className="btn"
            >
              Confirm
            </p>
          </div>

          {inputselected ? (
            <img
              className="arrow"
              src="/assets/images/icons/green-arrow.png"
              alt="icon"
            />
          ) : (
            <img
              className="arrow"
              src="/assets/images/icons/arrow.png"
              alt="icon"
            />
          )}
          {/* train-test-split */}
          <div className="test-train-split dataset-card">
            {!inputselected && <div className="blocker"></div>}
            {animationdone && <div className="blocker"></div>}
            <div className="sub-header">
              <p>Step 4</p>

              {splitselected && (
                <img src="/assets/images/icons/completed.png" alt="icon" />
              )}
            </div>
            <h4 className="sub-title">Train-Test Split</h4>
            <>
              {columns.length !== 0 ||
              ipColumns.length > 0 ||
              opColumns.length > 0 ? (
                <div className="card-body text-left m-2 0">
                  <Grid container spacing={2}>
                    <Grid item>Train Test Split</Grid>
                    <Grid item xs>
                      <Slider
                        value={value}
                        onChange={handleChange}
                        aria-labelledby="continuous-slider"
                        valueLabelDisplay="auto"
                      />
                    </Grid>
                    <Grid item>{value}</Grid>
                  </Grid>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <p style={{ flex: "0.6" }}>Train</p>
                    <p>Test</p>
                  </div>
                </div>
              ) : zipfile.length > 2 ? (
                <React.Fragment>
                  <div className="card-body text-left m-2 mb-0">
                    <Grid container spacing={2}>
                      <Grid item>Cycles</Grid>
                      <Grid item xs>
                        <Slider
                          min={1}
                          max={20}
                          value={epochs}
                          onChange={handleepochchange}
                          aria-labelledby="continuous-slider"
                          valueLabelDisplay="auto"
                        />
                      </Grid>
                      <Grid item>{epochs}</Grid>
                    </Grid>
                  </div>
                  <div className="card-body text-left m-2 mb-0">
                    <Grid container spacing={2}>
                      <Grid item>Train Test Split</Grid>
                      <Grid item xs>
                        <Slider
                          value={value}
                          onChange={handleChange}
                          aria-labelledby="continuous-slider"
                          valueLabelDisplay="auto"
                        />
                      </Grid>
                      <Grid item>{value}</Grid>
                    </Grid>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
            </>
            <p
              onClick={() => {
                setSplitSelected(true);
              }}
              className="btn"
            >
              Confirm
            </p>
          </div>

          {splitselected ? (
            <img
              className="arrow"
              src="/assets/images/icons/green-arrow.png"
              alt="icon"
            />
          ) : (
            <img
              className="arrow"
              src="/assets/images/icons/arrow.png"
              alt="icon"
            />
          )}

          {/* Algorithm selection */}
          <div className="algorithm-selection dataset-card">
            {!splitselected && <div className="blocker"></div>}
            {animationdone && <div className="blocker"></div>}
            <div className="sub-header">
              <p>Step 5</p>

              {algoselected && (
                <img src="/assets/images/icons/completed.png" alt="icon" />
              )}
            </div>
            <h4 className="sub-title">Algorithm Selection</h4>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <div
                style={{
                  display: "flex",
                  backgroundColor: "#5D7886",
                  marginBottom: "0.5rem",
                  padding: "0.5rem 1rem",
                  borderRadius: "0.5rem",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <h5>Classification</h5>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign: "center",
                    margin: "auto",
                  }}
                >
                  <label className="hiddenradio">
                    <input type="radio" name="mlmodel" value="SVC" id="SVC" />
                    <img
                      className="algomodelsimg"
                      alt="SVC"
                      src="/assets/images/icons/perceptron.png"
                    />
                    <p className="algotext p-0 m-0">SVC</p>
                  </label>
                </div>
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <label className="hiddenradio">
                    <input type="radio" name="mlmodel" value="RFC" id="RFC" />
                    <img
                      className="algomodelsimg"
                      alt="RFC"
                      src="/assets/images/icons/rfc.png"
                    />
                    <p className="algotext p-0 m-0">Random Forest Classifier</p>
                  </label>
                  <label className="hiddenradio">
                    <input type="radio" name="mlmodel" value="DTC" id="DTC" />
                    <img
                      className="algomodelsimg"
                      alt="DTC"
                      src="/assets/images/icons/dtc.png"
                    />
                    <p className="algotext p-0 m-0">Decision Tree Classifier</p>
                  </label>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  backgroundColor: "#5D7886",
                  marginBottom: "0.5rem",
                  padding: "0.5rem 1rem",
                  borderRadius: "0.5rem",
                  width: "100%",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <h5>Regression</h5>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <label className="hiddenradio">
                    <input type="radio" name="mlmodel" value="OLS" id="OLS" />
                    <img
                      className="algomodelsimg"
                      alt="LinearR"
                      src="/assets/images/icons/sgd.png"
                    />
                    <p className="algotext p-0 m-0">Linear Regression OLS</p>
                  </label>
                  <label className="hiddenradio">
                    <input type="radio" name="mlmodel" value="SGD" id="SGD" />
                    <img
                      className="algomodelsimg"
                      alt="SGD"
                      src="/assets/images/icons/sgd.png"
                    />
                    <p className="algotext p-0 m-0">Linear Regression SGD</p>
                  </label>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <label className="hiddenradio">
                    <input type="radio" name="mlmodel" value="DTR" id="DTR" />
                    <img
                      className="algomodelsimg"
                      alt="DTR"
                      src="/assets/images/icons/dtr.png"
                    />
                    <p className="algotext p-0 m-0">Decision Tree Regressor</p>
                  </label>
                  <label className="hiddenradio">
                    <input type="radio" name="mlmodel" value="RFR" id="RFR" />
                    <img
                      className="algomodelsimg"
                      alt="RFR"
                      src="/assets/images/icons/rfr.png"
                    />
                    <p className="algotext p-0 m-0">Random Forest Regressor</p>
                  </label>
                </div>
              </div>
            </div>

            <p
              onClick={() => {
                if ($("input[name='mlmodel']:checked").val() === undefined) {
                  Swal.fire("Please select a algorithm");
                } else {
                  setAlgoSelected(true);
                  setProgressLines({
                    one: "nostarted",
                    two: "nostarted",
                    three: "nostarted",
                    four: "nostarted",
                    five: "nostarted",
                  });
                  setAnimationran(false);
                  setAnimationdone(false);
                  setBuilded(false);
                  setShowScore(false);
                  setTrained(false);
                }
              }}
              className="btn"
            >
              Confirm
            </p>
          </div>

          {algoselected ? (
            <img
              className="arrow"
              src="/assets/images/icons/green-arrow.png"
              alt="icon"
            />
          ) : (
            <img
              className="arrow"
              src="/assets/images/icons/arrow.png"
              alt="icon"
            />
          )}
          {/* building */}
          <div className="building dataset-card">
            {!algoselected && <div className="blocker"></div>}
            <div className="sub-header">
              <p>Step 6</p>

              {trained && (
                <img src="/assets/images/icons/completed.png" alt="icon" />
              )}
            </div>
            <h4 className="sub-title">Model Training</h4>

            {builded && (
              <>
                {progressLines["one"] === "" && (
                  <p>Please wait uploading dataset...</p>
                )}

                {progressLines["one"] === "started" ? (
                  <div style={{ display: "flex" }}>
                    <Fade
                      in={progressLines["one"] === "started"}
                      style={{
                        transitionDelay: "0ms",
                        width: "1.5rem",
                        height: "1.5rem",
                        marginRight: "0.3rem",
                        marginLeft: "0.2rem",
                      }}
                      unmountOnExit
                    >
                      <CircularProgress />
                    </Fade>
                    <p>
                      {uploadMode === "link"
                        ? `Reading ${document.getElementById("outlined-basic").value}`
                        : `Reading ${filename} file`}
                    </p>
                  </div>
                ) : (
                  progressLines["one"] === "completed" && (
                    <div style={{ display: "flex" }}>
                      <CheckCircleIcon style={{ width: "2rem" }} />
                      <p>
                        {uploadMode === "link"
                          ? `Reading ${document.getElementById("outlined-basic").value}`
                          : `Reading ${filename} file`}
                      </p>
                    </div>
                  )
                )}

                {progressLines["two"] === "started" ? (
                  <div style={{ display: "flex" }}>
                    <Fade
                      in={progressLines["two"] === "started"}
                      style={{
                        transitionDelay: "0ms",
                        width: "1.5rem",
                        height: "1.5rem",
                        marginRight: "0.3rem",
                        marginLeft: "0.2rem",
                      }}
                      unmountOnExit
                    >
                      <CircularProgress />
                    </Fade>
                    <p>
                      {mappingjson["algorithm"] !== "IC"
                        ? `Train-test split: ${(1 - mappingjson["testsize"]) * 100}%-${mappingjson["testsize"] * 100}%`
                        : `Train-test split: ${(1 - mappingjson["testsize"]) * 100}%-${mappingjson["testsize"] * 100}%
                     cycles: ${mappingjson["epochs"]}`}
                    </p>
                  </div>
                ) : (
                  progressLines["two"] === "completed" && (
                    <div style={{ display: "flex" }}>
                      <CheckCircleIcon style={{ width: "2rem" }} />
                      <p>
                        {mappingjson["algorithm"] !== "IC"
                          ? `Train-test split: ${(1 - mappingjson["testsize"]) * 100}%-${mappingjson["testsize"] * 100}%`
                          : `Train-test split: ${(1 - mappingjson["testsize"]) * 100}%-${mappingjson["testsize"] * 100}%
                     cycles: ${mappingjson["epochs"]}`}
                      </p>
                    </div>
                  )
                )}

                {progressLines["three"] === "started" ? (
                  <div style={{ display: "flex" }}>
                    <Fade
                      in={progressLines["three"] === "started"}
                      style={{
                        transitionDelay: "0ms",
                        width: "1.5rem",
                        height: "1.5rem",
                        marginRight: "0.3rem",
                        marginLeft: "0.2rem",
                      }}
                      unmountOnExit
                    >
                      <CircularProgress />
                    </Fade>
                    <p>
                      {mappingjson["algorithm"] !== "IC"
                        ? `Training the model with ${mappingjson["algorithm"]} algorithm on ${(1 - mappingjson["testsize"]) * 100}% of the dataset`
                        : "Training the model with Image Classifier algorithm"}
                    </p>
                  </div>
                ) : (
                  progressLines["three"] === "completed" && (
                    <div style={{ display: "flex" }}>
                      <CheckCircleIcon style={{ width: "2rem" }} />
                      <p>
                        {mappingjson["algorithm"] !== "IC"
                          ? `Training the model with ${mappingjson["algorithm"]} algorithm on ${(1 - mappingjson["testsize"]) * 100}% of the dataset`
                          : "Training the model with Image Classifier algorithm"}
                      </p>
                    </div>
                  )
                )}

                {progressLines["four"] === "started" ? (
                  <div style={{ display: "flex" }}>
                    <Fade
                      in={progressLines["four"] === "started"}
                      style={{
                        transitionDelay: "0ms",
                        width: "1.5rem",
                        height: "1.5rem",
                        marginRight: "0.3rem",
                        marginLeft: "0.2rem",
                      }}
                      unmountOnExit
                    >
                      <CircularProgress />
                    </Fade>
                    <p>{`Testing the model on ${mappingjson["testsize"] * 100}% of the dataset`}</p>
                  </div>
                ) : (
                  progressLines["four"] === "completed" && (
                    <div style={{ display: "flex" }}>
                      <CheckCircleIcon style={{ width: "2rem" }} />
                      <p>{`Testing the model on ${mappingjson["testsize"] * 100}% of the dataset`}</p>
                    </div>
                  )
                )}

                {progressLines["five"] === "started" ? (
                  <div style={{ display: "flex" }}>
                    <Fade
                      in={progressLines["five"] === "started"}
                      style={{
                        transitionDelay: "0ms",
                        width: "1.5rem",
                        height: "1.5rem",
                        marginRight: "0.3rem",
                        marginLeft: "0.2rem",
                      }}
                      unmountOnExit
                    >
                      <CircularProgress />
                    </Fade>
                    <p>Model trained</p>
                  </div>
                ) : (
                  progressLines["five"] === "completed" && (
                    <div style={{ display: "flex" }}>
                      <CheckCircleIcon style={{ width: "2rem" }} />
                      <p>Model trained</p>
                    </div>
                  )
                )}
              </>
            )}
            <p
              onClick={() => {
                handleModelOpen();
                handleTextAnimations();
                console.log(builded);
              }}
              className="btn"
              style={
                !builded ? { display: "inline-block" } : { display: "none" }
              }
            >
              Train
            </p>
          </div>
          {trained ? (
            <img
              className="arrow"
              src="/assets/images/icons/green-arrow.png"
              alt="icon"
            />
          ) : (
            <img
              className="arrow"
              src="/assets/images/icons/arrow.png"
              alt="icon"
            />
          )}
          {/*console */}
          <div className="console dataset-card">
            {!trained && <div className="blocker"></div>}
            {animationdone && <div className="blocker"></div>}
            <div className="sub-header">
              <p>Step 7</p>

              {trained && (
                <img src="/assets/images/icons/completed.png" alt="icon" />
              )}
            </div>
            <h4 className="sub-title">Check Result</h4>

            {showScores ? (
              <>
                {responseJson.hasOwnProperty("scores") ? (
                  <>
                    <p></p>
                    {algoType === "classification" ? (
                      <>
                        <p>{`Accuracy Score : ${responseJson["scores"]["accuracy_score"]}`}</p>
                        <p>{`F1 Score : ${responseJson["scores"]["f1_score"]}`}</p>
                        <p>{`Precision Score : ${responseJson["scores"]["precision_score"]}`}</p>
                        <p>{`Recall Score : ${responseJson["scores"]["recall_score"]}`}</p>
                      </>
                    ) : (
                      <></>
                    )}
                    {algoType === "regression" ? (
                      <>
                        <p>{`r2 Score : ${responseJson["scores"]["r2_score"]}`}</p>
                        <p>{`Mean Squared Error : ${responseJson["scores"]["mean_squared_error"]}`}</p>
                        <p>{`Mean Absolute Error: ${responseJson["scores"]["mean_absolute_error"]}`}</p>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    <p>Build failed, Improper dataset uploaded</p>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
          </div>

          {trained ? (
            <img
              className="arrow"
              src="/assets/images/icons/green-arrow.png"
              alt="icon"
            />
          ) : (
            <img
              className="arrow"
              src="/assets/images/icons/arrow.png"
              alt="icon"
            />
          )}
          {/* test with real world data */}
          <div className="real-world-data dataset-card">
            {!trained && <div className="blocker"></div>}
            {animationdone && <div className="blocker"></div>}
            <div className="sub-header">
              <p>Step 8</p>

              {/* {
                filename !== "No file uploaded" && <img src="/assets/images/icons/completed.png" />
              } */}
            </div>
            <h4 className="sub-title">Test with real world data</h4>
            {trained && <TestingForm />}
          </div>
        </div>
      </div>
    </>
  );
}
